export default "__VITE_ASSET__CSebHucC__"